import { render, staticRenderFns } from "./EditAccountDialog.vue?vue&type=template&id=552a9068&scoped=true"
import script from "./EditAccountDialog.vue?vue&type=script&lang=js"
export * from "./EditAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAccountDialog.vue?vue&type=style&index=0&id=552a9068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a9068",
  null
  
)

export default component.exports